module.exports = __webpack_public_path__ + "static/sjopenna_2k-7b5e64b8c55351f5af523a3495cb82a2.webp";